import { PaymentSessionSecrets, PaymentSessionType } from '@/api/payments';
import { axios } from '@/common/axios';
import { APIResponse } from '@/common/types';

export type PaymentSessionResponse = APIResponse<PaymentSessionSecrets>;

export const createPaymentSession = async (type: PaymentSessionType): Promise<PaymentSessionResponse> => {
    return axios.post<PaymentSessionResponse, PaymentSessionResponse>('/api/v2/payments/session', {
        type,
    });
};
